import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

// Portal pattern: allows us to declare a component as a child
// of another component, but actually render it somewhere else
// within the DOM. In React, this allows us to declare components
// within a context (with it's props and state).
// It consists of two Components:
// PortalOrigin: Wraps the Component that will be rendered elsewhere
// PortalDestination: Place it where you want to render the component
// wrapped by the Portal Origin.
export const PortalOrigin = props => {
  const el = useRef(document.createElement('div'));
  useEffect(() => {
    const portal = document.querySelector('#portal');
    portal.appendChild(el.current);

    return () => portal.removeChild(el.current);
  }, [props.children]);

  return ReactDOM.createPortal(props.children, el.current);
};

export const PortalDestination = () => <div id="portal" />;
